<template lang="pug">
  b-button.action(:variant="variant" ,@click="updateStatus($event, actionId)") {{ text }}
</template>

<script>
export default {
  name: 'action_button',
  props: ['variant', 'actionId', 'text'],
  data() {
    return {
      action: {},
    };
  },
  methods: {
    updateStatus($event, statusId) {
      const buttons = document.querySelectorAll('.buttons-container .btn');
      const complaintActions = document.querySelector('.complaint-actions');
      const thisButton = $event.target;
      const inactiveClass = 'btn-inactive';
      const selected = this.$store.state.selected.aasm_state;

      complaintActions.classList.add('has-active-option');

      buttons.forEach((currentButton) => {
        currentButton.classList.remove(inactiveClass);

        if (currentButton !== thisButton) {
          currentButton.classList.add(inactiveClass);
        }
      });

      this.action.status = statusId;

      // TODO: Refactor. This code is too complex
      if (this.action.status === 'rejected_communication' && ['pending_err', 'pending_edb'].includes(selected)) {
        this.$emit('extra', { code: 'rejection', next: statusId });
      } else if (this.action.status === 'approved_reimbursement') {
        this.$emit('extra', { code: 'approval', next: statusId });
      } else if (this.action.status === 'pending_edb') {
        this.$emit('extra', { code: 'bus-operator', next: statusId });
      } else if (this.action.status === 'pending_info') {
        this.$emit('extra', { code: 'more-information', next: statusId });
      } else if (this.action.status === 'pending_requested') {
        this.$emit('extra', { code: 'more-information', next: statusId });
      } else if (this.action.status === 'notified_rejection') {
        this.$emit('extra', { code: 'rejection-message', next: statusId });
      } else if (this.action.status === 'notified_approval' && ['approved_communication'].includes(selected)) {
        this.$emit('extra', { code: 'approval-message', next: statusId });
      } else if (this.action.status === 'pending_err') {
        this.$emit('extra', { code: 'to-err', next: statusId });
      } else {
        this.$emit('extra', { code: '-', next: statusId });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/layout/ActionButton.vue